
import { computed, defineComponent, ref } from "vue";
import Jumbotorn from "@/components/common/Jumbotron.vue";
import { RouterName } from "@/models/common";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "OnlineCare Intro",
  props: {
    linkPath: String,
    isImage: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const linkTo = computed(() => {
      return props.linkPath
        ? { name: props.linkPath }
        : { name: RouterName.ONLINE_CARE_REQUEST_NEW };
    });
    const isMobileShow = ref(props.isImage);

    const { t } = useI18n({ useScope: "global" });

    return { linkTo, isMobileShow, t };
  },
  components: {
    Jumbotorn,
  },
});
